import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTitle } from '../../context/TitleContext';
import { Row, Col, Button } from 'react-bootstrap';
import AddSupplier from './components/AddSupplier';
import '../../styles/products.scss';

const SupplierCreate = () => {
  const { setTitle } = useTitle();
  const navigate = useNavigate();

  useState(() => {
    setTitle('Créer un Fournisseur');
  }, [setTitle]);

  const handleCancel = () => {
    navigate('/admin/suppliers/supplier-list');
  };

  return (
    <div className="supplier-create-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddSupplier isEdit={false} />
        </Col>
      </Row>
    </div>
  );
};

export default SupplierCreate;